import {
  FilterCategoryModel,
  FilterItemModel,
} from "@/models/filterItem.model";
import { KioskModel } from "@/models/kiosk.model";
import Cafe from "@/assets/cafés.svg";
import Fashion from "@/assets/fashion.svg";
import ATM from "@/assets/atm.svg";
import CustomerServiceDesk from "@/assets/info.svg";
import Desserts from "@/assets/confectionary.svg";
import Entrance from "@/assets/entrance.svg";
import FastFood from "@/assets/fast_food.svg";
import GiftCard from "@/assets/gift_cards.svg";
import HomeTech from "@/assets/home&tech.svg";
import Hypermarket from "@/assets/hypermarkets.svg";
import JewelleryWatches from "@/assets/jewellery_&_watches.svg";
import LostFound from "@/assets/box.svg";
// import LuggageBagDrop from '@/assets/luggage_bag_drop.svg';
import MallManager from "@/assets/manager.svg";
import Parking from "@/assets/parking.svg";
import PrayerRoomMale from "@/assets/prayer_room_female.svg";
import PrayerRoomFemale from "@/assets/prayer_room_male.svg";
import RedCrescent from "@/assets/charity.svg";
import RestroomFemale from "@/assets/female.svg";
import RestroomMale from "@/assets/men.svg";
import Taxi from "@/assets/taxi.svg";
import UberCareem from "@/assets/uber.svg";
import ValetParking from "@/assets/valet.svg";
import Wifi from "@/assets/wifi.svg";
import Share from "@/assets/coin.svg";
import Wheelchair from "@/assets/wheelchair.svg";
import BabyChangingFemale from "@/assets/changing.svg";
import BabyChangingMale from "@/assets/changing-1.svg";
import ParkingAssist from "@/assets/park_assist.svg";
import FirstAid from "@/assets/first_aid.svg";
import AccessibleParking from "@/assets/accessible-parking.svg";
import FemaleAccessibleToilet from "@/assets/accessible-toilet-F.svg";
import MaleAccessibleToilet from "@/assets/accessible-toilet-M.svg";
import Hotel from "@/assets/hotel-solid.svg";
import HotelWhite from "@/assets/hotel-solid-white.svg";
import Facilities from "@/assets/facilities-ultra.svg";
import FacilitiesWhite from "@/assets/facilities-ultra-white.svg";
import BabyFeeding from "@/assets/baby-feeding.svg";
import Bus from "@/assets/bus.svg";
import { FaBagShopping, FaFaceSmile, FaUtensils } from "react-icons/fa6";
import { AmenityModel } from "proximiio-js-library/lib/models/amenity";
import Feature from "proximiio-js-library/lib/models/feature";
import Entertainment from "@/assets/entertainment.svg";
import iFly from "@/assets/ifly.svg";
import LittleExplorers from "@/assets/little-explorers.svg";
import MagicPlanet from "@/assets/magic-planet.svg";
import Snow from "@/assets/snow.svg";
import VoxCinema from "@/assets/vox-cinema.svg";

import Banks from "@/assets/project-assets/banks.svg";
import Books from "@/assets/project-assets/books.svg";
import Electronics from "@/assets/project-assets/electronics.svg";
import FashionAccessories from "@/assets/project-assets/fashions-accessoiries.svg";
import FashionLadies from "@/assets/project-assets/fashionlandies.svg";
import FashionMen from "@/assets/project-assets/fashionmen.svg";
import FashionUnisex from "@/assets/project-assets/fashionunisex.svg";
import Swimwear from "@/assets/project-assets/swimwear.svg";
import Optics from "@/assets/project-assets/optics.svg";
import Pharmacies from "@/assets/project-assets/phamacies.svg";
import Speciality from "@/assets/project-assets/servicesandspecialitystores.svg";
import SportsWear from "@/assets/project-assets/sportswear.svg";
import ForkKnife from "@/assets/project-assets/fork-knife.svg";

export const getListAsClosest = () => {
  const closestList = [];
  for (const category of filterCategories) {
    closestList.push(category.items.filter((item) => item.listAsClosest));
  }
  return closestList.flat(2);
};

export const getHiddenItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter((item) => item.hideMapIcon)) {
      list.push(item.id);
    }
  }
  return list.flat(2);
};

export const getExcludedItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter(
      (item) => item.excludeFromSearch,
    )) {
      list.push(item.id);
    }
  }
  return list.flat(2);
};

export const getHiddenUntilSelectedItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter(
      (item) => item.hideIconUntilSelected,
    )) {
      list.push(item.id);
    }
  }
  return list.flat();
};

export const filterCategories: FilterCategoryModel[] = [
  {
    title: "shop",
    id: "shop",
    color: "185.6,100%,41.8%",
    icon: FaBagShopping,
    items: [
      {
        title: "banks-financial",
        iconImage: Banks,
        id: [
          "b5fe8767-8a52-4635-94d0-d9df03702e7b:2a2a1a52-d866-41a8-94e0-ca243d61b032",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "books-stationery-toys-games-gifts",
        iconImage: Books,
        id: [
          "b5fe8767-8a52-4635-94d0-d9df03702e7b:eeb18ff9-3f00-48e5-b638-bb5363707155",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "electronics-home-mobile",
        iconImage: Electronics,
        id: [
          "b5fe8767-8a52-4635-94d0-d9df03702e7b:040960d2-7e2f-470e-abdb-aa8dd5421a08",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fashion-accessories",
        iconImage: FashionAccessories,
        id: [
          "b5fe8767-8a52-4635-94d0-d9df03702e7b:9bebbd33-85b8-4e2f-a0d1-5ad7f3847663",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fashion-child",
        iconImage: Fashion,
        id: [
          "b5fe8767-8a52-4635-94d0-d9df03702e7b:82daa1b2-ca73-49f2-88c8-3021a68ecda7",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fashion-ladies",
        iconImage: FashionLadies,
        id: [
          "b5fe8767-8a52-4635-94d0-d9df03702e7b:89c2e593-8b83-407f-b28a-1a1f70efa308",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fashion-men",
        iconImage: FashionMen,
        id: [
          "b5fe8767-8a52-4635-94d0-d9df03702e7b:615d59a1-6535-4345-9db3-5acbf387a111",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fashion-unisex",
        iconImage: FashionUnisex,
        id: [
          "b5fe8767-8a52-4635-94d0-d9df03702e7b:e8d9f533-d063-4b12-9995-3eb2e801c6c6",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "household-furtniture-carpet",
        iconImage: HomeTech,
        id: [
          "b5fe8767-8a52-4635-94d0-d9df03702e7b:34be7c73-16a3-496a-bc76-6ea9c1c34de2",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "hypermarket",
        iconImage: Hypermarket,
        id: [
          "b5fe8767-8a52-4635-94d0-d9df03702e7b:b4f63840-d27d-46dc-bc1a-652c82d0e748",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "jewellery-watches",
        iconImage: JewelleryWatches,
        id: [
          "b5fe8767-8a52-4635-94d0-d9df03702e7b:9a7bc3ec-c0a8-47af-861c-d2f323806f53",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "lingerie-swimwear",
        iconImage: Swimwear,
        id: [
          "b5fe8767-8a52-4635-94d0-d9df03702e7b:17389892-a9df-4f53-8aad-c03e74038644",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "optics-sunglasses",
        iconImage: Optics,
        id: [
          "b5fe8767-8a52-4635-94d0-d9df03702e7b:8c8d477a-ef0a-47b7-9e41-1d3f56444de4",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "pharmacy-health-fitness-cosmetics-perfumes",
        iconImage: Pharmacies,
        id: [
          "b5fe8767-8a52-4635-94d0-d9df03702e7b:caf7d499-cae4-4d71-b87f-d9b12a6d7b79",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "speciality-stores",
        iconImage: Speciality,
        id: [
          "b5fe8767-8a52-4635-94d0-d9df03702e7b:0d23a97e-c9fc-4e95-a03e-bef2c79ba02a",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "sportswear-goods",
        iconImage: SportsWear,
        id: [
          "b5fe8767-8a52-4635-94d0-d9df03702e7b:a8ed920f-06bf-4e50-ad4b-7a937f300d66",
        ],
        type: "list",
        hideMapIcon: true,
      },
    ],
  },
  {
    title: "dine",
    id: "dine",
    color: "10.6,100%,61.2%",
    icon: FaUtensils,
    items: [
      {
        title: "cafes",
        iconImage: Cafe,
        id: [
          "b5fe8767-8a52-4635-94d0-d9df03702e7b:d1ec05d5-505f-492f-b7a8-aeff862e0b19",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "chocolates-confectionery-icecream",
        iconImage: Desserts,
        id: [
          "b5fe8767-8a52-4635-94d0-d9df03702e7b:447a88c2-758a-48e6-a64f-482519d0e74a",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fast-food",
        iconImage: FastFood,
        id: [
          "b5fe8767-8a52-4635-94d0-d9df03702e7b:f4d88745-8485-4f8b-88e5-5925bd51f863",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "restaurants",
        iconImage: ForkKnife,
        id: [
          "b5fe8767-8a52-4635-94d0-d9df03702e7b:5355a808-df56-4a71-86c9-f4497994c656",
        ],
        type: "list",
        hideMapIcon: true,
      },
    ],
  },
  {
    title: "entertainment",
    id: "entertainment",
    color: "284.4,100%,38.4%",
    icon: FaFaceSmile,
    items: [],
  },
  {
    title: "hotels",
    id: "hotels",
    color: "208,100%,33%",
    iconImage: Hotel,
    iconImageAlt: HotelWhite,
    listed: false,
    items: [
      {
        title: "female-prayer-room",
        iconImage: PrayerRoomFemale,
        id: "be10bdce-cd82-4c67-8559-2e6b8e78d587:5ce8d16a-e795-4e2c-802c-083312db4d06",
        type: "list",
        hideMapIcon: true,
      },
    ],
  },
  {
    title: "facilities",
    id: "facilities",
    color: "40.6,99%,61.4%",
    iconImage: Facilities,
    iconImageAlt: FacilitiesWhite,
    items: [
      {
        title: "female-prayer-room",
        iconImage: PrayerRoomFemale,
        id: "b5fe8767-8a52-4635-94d0-d9df03702e7b:0dfcd12b-eabd-43de-81c3-0c14db31067c",
        type: "list",
        hideIconUntilSelected: false,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "male-prayer-room",
        iconImage: PrayerRoomMale,
        id: "b5fe8767-8a52-4635-94d0-d9df03702e7b:dca9dcdd-aa82-40e7-b014-69f69ba492e5",
        type: "list",
        hideIconUntilSelected: false,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "female-toilet",
        iconImage: RestroomFemale,
        id: "b5fe8767-8a52-4635-94d0-d9df03702e7b:8bfeaee8-9aab-4194-986a-0f9505c5583c",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        hideMapIcon: false,
      },
      {
        title: "male-toilet",
        iconImage: RestroomMale,
        id: "b5fe8767-8a52-4635-94d0-d9df03702e7b:743ae60d-930c-42ed-9116-d07bd6ca28cb",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        hideMapIcon: false,
      },
      {
        title: "atm",
        iconImage: ATM,
        id: "b5fe8767-8a52-4635-94d0-d9df03702e7b:2afbf595-9a52-4e69-be66-92453ac88922",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "customer-service-desk",
        iconImage: CustomerServiceDesk,
        id: "b5fe8767-8a52-4635-94d0-d9df03702e7b:df4471a0-3085-4b2d-aa23-45a9f16c67ea",
        type: "closest",
        hideIconUntilSelected: false,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "baby-care-room",
        iconImage: BabyFeeding,
        id: "b5fe8767-8a52-4635-94d0-d9df03702e7b:9d72ebd8-ae3e-4909-8420-3bd10c79e7e2",
        type: "closest",
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "baby-changing-room-female",
        iconImage: BabyChangingFemale,
        id: "b5fe8767-8a52-4635-94d0-d9df03702e7b:8bfeaee8-9aab-4194-986a-0f9505c5583c",
        type: "closest",
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "baby-changing-room-male",
        iconImage: BabyChangingMale,
        id: "b5fe8767-8a52-4635-94d0-d9df03702e7b:743ae60d-930c-42ed-9116-d07bd6ca28cb",
        type: "closest",
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "female-accessible-toilet",
        iconImage: FemaleAccessibleToilet,
        id: "b5fe8767-8a52-4635-94d0-d9df03702e7b:8bfeaee8-9aab-4194-986a-0f9505c5583c",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        hideMapIcon: false,
      },
      {
        title: "male-accessible-toilet",
        iconImage: MaleAccessibleToilet,
        id: "b5fe8767-8a52-4635-94d0-d9df03702e7b:743ae60d-930c-42ed-9116-d07bd6ca28cb",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        hideMapIcon: false,
      },
      {
        title: "taxi-stand",
        iconImage: Taxi,
        id: "b5fe8767-8a52-4635-94d0-d9df03702e7b:5762695d-029b-44c7-931a-7845641adbca",
        type: "list",
        hideIconUntilSelected: false,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "uber-careem",
        iconImage: UberCareem,
        id: "b5fe8767-8a52-4635-94d0-d9df03702e7b:1f8f26a7-c786-4345-ac23-fc36384a6a16",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "bus-stop",
        iconImage: Bus,
        id: "b5fe8767-8a52-4635-94d0-d9df03702e7b:383b1948-9508-458b-a43c-ae7f4da378e0",
        type: "list",
        hideIconUntilSelected: false,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "entrance",
        iconImage: Entrance,
        id: "b5fe8767-8a52-4635-94d0-d9df03702e7b:f4dfb34a-9096-47e7-8daa-c476ae261684",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "parking",
        iconImage: Parking,
        id: "b5fe8767-8a52-4635-94d0-d9df03702e7b:ec7c6406-5499-4b0a-81e1-a80f760c6d29",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "valet-parking",
        iconImage: ValetParking,
        id: "b5fe8767-8a52-4635-94d0-d9df03702e7b:bf1b25cc-6043-4fd3-8c97-db60e4c65ec2",
        type: "list",
        excludeFromSearch: false,
        hideIconUntilSelected: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "pod-parking",
        iconImage: AccessibleParking,
        id: "b5fe8767-8a52-4635-94d0-d9df03702e7b:a5016f4f-6a4d-4859-af36-ef4f2063fdb3",
        type: "list",
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "find-my-car-kiosk",
        iconImage: ParkingAssist,
        id: "b5fe8767-8a52-4635-94d0-d9df03702e7b:04f850e6-66d1-4bc1-b0a5-82cc5d4eae41",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "charity",
        iconImage: RedCrescent,
        id: "b5fe8767-8a52-4635-94d0-d9df03702e7b:272c5e35-543b-4409-94a7-ae2d8c6c46e0",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "lost-found",
        iconImage: LostFound,
        id: [
          "b5fe8767-8a52-4635-94d0-d9df03702e7b:d212c8f8-fb4c-48ab-811e-c7b25e53138d",
        ],
        type: "closest",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "first-aid-room",
        iconImage: FirstAid,
        id: "b5fe8767-8a52-4635-94d0-d9df03702e7b:5beb2b8d-5a84-4ef4-922d-fd2b23c9b99d",
        type: "closest",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "wheelchairs",
        iconImage: Wheelchair,
        id: "b5fe8767-8a52-4635-94d0-d9df03702e7b:c9504699-99fb-4feb-908d-23df998b7e27",
        type: "closest",
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "gift-card",
        iconImage: GiftCard,
        id: "b5fe8767-8a52-4635-94d0-d9df03702e7b:df4471a0-3085-4b2d-aa23-45a9f16c67ea",
        type: "closest",
        hideIconUntilSelected: false,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "mall-management-office",
        iconImage: MallManager,
        id: "b5fe8767-8a52-4635-94d0-d9df03702e7b:08b3c47b-a17c-473f-bdc2-77934e3204e4",
        type: "closest",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "parking-bays",
        id: [
          "b5fe8767-8a52-4635-94d0-d9df03702e7b:df9b0b22-b124-4a99-9667-8b9cc1684dc7",
          "b5fe8767-8a52-4635-94d0-d9df03702e7b:14f39d60-51b6-4e69-9a1f-8f621a8c717b",
          "b5fe8767-8a52-4635-94d0-d9df03702e7b:c1b4c6f5-b54c-4ab8-85c9-f3e5df3c64d5",
        ],
        type: "list",
        listed: false,
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "vacant",
        id: [
          "b5fe8767-8a52-4635-94d0-d9df03702e7b:b4c9edea-8027-4615-b881-498ec4262aee",
        ],
        type: "list",
        listed: false,
        hideMapIcon: true,
        excludeFromSearch: true,
        hideIconUntilSelected: true,
        listAsClosest: false,
      },
      {
        title: "others",
        id: [
          "b5fe8767-8a52-4635-94d0-d9df03702e7b:bec512e6-f617-4522-ad36-d7b162d38c3d",
        ],
        type: "list",
        listed: false,
        hideMapIcon: true,
        excludeFromSearch: false,
        hideIconUntilSelected: true,
        listAsClosest: false,
      },
      {
        title: "wifi",
        iconImage: Wifi,
        type: "info",
        listed: false,
        content: {
          en: `
						<h3 class="text-xl font-bold my-4">#Free_ Mall_WiFi</h3>
						<p class="font-bold mb-4">We Understand that staying connected is important in today’s world. That’s why we’re excited to offer #Free_ Mall_WiFi to all our shoppers.</p>
						<ul class="mb-4">
							<li>1. Please choose #Free_Mall_WiFi from the list of Wi-Fi networks.</li>
							<li>2. Your device should automatically be taken to our login page.</li>
							<li>3. Enter your details and follow the instructions to gain high-speed internet service.</li>
						</ul>
					`,
          ar: `
						<h3 class="text-xl font-bold my-4">#Free_ Mall_WiFi</h3>
						<p class="font-bold mb-4">نحن نتفهم أن البقاء على اتصال أمر مهم في عالم اليوم.لهذا السبب نحن متحمسون لتقديم خدمة فري وايفاي لجميع المتسوقين لدينا</p>
						<ul>
							<li>من قائمة الشبكات #Free_Mall_WiFi الرجاء اختيار</li>
							<li>يجب أن يتم نقل جهازك تلقائيا إلى صفحة تسجيل الدخول الخاصة بنا</li>
							<li>أدخل بياناتك واتبع التعليمات للحصول على خدمة إنترنت عالي السرعة</li>
						</ul>
					`,
        },
      },
      {
        title: "share",
        iconImage: Share,
        type: "info",
        listed: false,
        content: {
          en: `
						<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary mt-4 block text-lg font-semibold">Join SHARE</a>
						<h3 class="text-2xl font-bold mb-6">Get More At City Centre Mirdif</h3>
						<p class="mb-6">As a member of the SHARE rewards programme, you get cash back in points at all stores and restaurants in City Centre Mirdif and beyond. Join the SHARE programme now – it’s free and will only take you a few minutes.</p>
						<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary text-lg font-semibold">Join SHARE Rewards</a>
					`,
          ar: `
					<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary mt-4 block text-lg font-semibold">سجلوا في تطبيق شير</a>
					<h3 class="text-2xl font-bold mb-6">احصلوا على المزيد في سيتي سنتر مردف</h3>
					<p class="mb-6">تخولكم عضويتكم في برنامج المكافآت شير استرداد بعض النقود في صورة نقاط لدى جميع المتاجر والمطاعم في سيتي سنتر مردف وأماكن أخرى خارج المول. انضموا إلى برنامج المكافآت شير الآن - فهو مجاني ولا يلزم لانضمامكم إليه سوى دقائق معدودة.</p>
					<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary text-lg font-semibold">سجلوا في تطبيق شير</a>
					`,
        },
      },
    ],
  },
];

filterCategories.push({
  title: "hidden",
  id: "hidden",
  listed: false,
  items: [
    {
      title: "hidden",
      id: getHiddenUntilSelectedItems() as string[],
      type: "list",
      listed: false,
    },
  ],
});

export const kiosks: KioskModel[] = [];

export const excludedAmenities: string[] = getExcludedItems() as string[];

// Function to build additional filters based on amenities and features
export const buildAdditionalFilters = ({
  amenities,
  features,
  language,
}: {
  amenities: AmenityModel[] | null;
  features: Feature[] | null;
  language: string;
}): FilterItemModel[] | void => {
  // Early exit if amenities or features are missing
  if (!amenities) {
    console.error("amenities is null");
    return;
  }

  if (!features) {
    console.error("features is null");
    return;
  }

  // Define amenity titles and their mapping to ids/features
  const amenityMapping: {
    [key: string]: {
      amenity?: AmenityModel;
      features: Feature[];
      icon: string;
    };
  } = {
    "Snow/Ski": { amenity: undefined, features: [], icon: Snow },
    "Vox Cinema": { amenity: undefined, features: [], icon: VoxCinema },
    "Magic Planet": { amenity: undefined, features: [], icon: MagicPlanet },
    iFLY: { amenity: undefined, features: [], icon: iFly },
    "Little Explorers": {
      amenity: undefined,
      features: [],
      icon: LittleExplorers,
    },
    Entertainment: { amenity: undefined, features: [], icon: Entertainment },
  };

  // Map amenities to their respective amenity titles
  for (const amenity of amenities) {
    if (amenityMapping[amenity.title]) {
      amenityMapping[amenity.title].amenity = amenity;
    }
  }

  // Map features to their respective amenities
  for (const feature of features) {
    for (const key in amenityMapping) {
      const { amenity } = amenityMapping[key];
      if (feature.properties?.amenity === amenity?.id) {
        amenityMapping[key].features.push(feature);
      }
    }
  }

  // Utility function to retrieve a translated title
  const getTranslatedTitle = (feature: Feature): string => {
    const { title_i18n, title } = feature.properties || {};
    return title_i18n?.[language] || title_i18n?.en || title;
  };

  const items: FilterItemModel[] = [];

  // Create filter items for each amenity based on available features
  for (const key in amenityMapping) {
    const { amenity, features, icon } = amenityMapping[key];

    if (amenity && features.length > 0) {
      let itemTitle: string | undefined;

      // If there is only one feature, use the feature title
      if (features.length === 1) {
        itemTitle = getTranslatedTitle(features[0]);
      }

      // Set up the item object for the filter list
      const baseItem: FilterItemModel = {
        title: key.toLowerCase().replace(/\s/g, "-"), // Convert title to kebab-case
        translatedTitle: itemTitle,
        iconImage: icon,
        id: [amenity.id],
        hideMapIcon: true,
        type: "list",
      };

      // Push items to the list based on the type (list or single)
      if (key === "Entertainment") {
        // For "Entertainment", push individual features
        features.forEach((feature) => {
          items.push({
            ...baseItem,
            type: "single",
            title: getTranslatedTitle(feature)
              .toLowerCase()
              .replace(/\s/g, "-"), // Convert title to kebab-case
            translatedTitle: getTranslatedTitle(feature),
            featureId: feature.id,
          });
        });
      } else {
        // For other amenities, push as a list
        items.push(baseItem);
      }
    }
  }

  const entertainmentIndex = filterCategories.findIndex(
    (category) => category.id === "entertainment",
  );
  filterCategories[entertainmentIndex].items = items;
};
